module.exports = __webpack_public_path__ + "static/media/human_body.c9341959.png";